import { parseISO, format, isSameMonth, isSameYear } from 'date-fns';

export default function formatDateRange(
	dateStr1: string,
	dateStr2: string,
	forceFullDateFormat = false
) {
	if (!dateStr2) {
		return format(parseISO(dateStr1), 'MMM d, y');
	} else {
		const [date1, date2] = [dateStr1, dateStr2]
			.map(dateStr => parseISO(dateStr))
			.map(date => {
				return {
					month: format(date, 'MMM'),
					day: format(date, 'd'),
					year: format(date, 'y'),
				};
			});

		const datesAreSameMonth = isSameMonth(parseISO(dateStr1), parseISO(dateStr2));
		const datesAreSameYear = isSameYear(parseISO(dateStr1), parseISO(dateStr2));

		const dateRange = `${date1.month} ${date1.day}`;

		if (!datesAreSameYear) {
			return `${dateRange}, ${date1.year} - ${date2.month} ${date2.day}, ${date2.year}`;
		} else {
			return (
				dateRange +
				(!datesAreSameMonth || forceFullDateFormat
					? ` - ${date2.month} ${date2.day},`
					: ` - ${date2.day},`) +
				` ${date1.year}`
			);
		}
	}
}

export function formatDateRangeShort(dateStr1: string, dateStr2: string) {
	if (!dateStr2) {
		return format(parseISO(dateStr1), 'MMM d');
	} else {
		const [date1, date2] = [dateStr1, dateStr2]
			.map(dateStr => parseISO(dateStr))
			.map(date => {
				return {
					month: format(date, 'MMM'),
					day: format(date, 'd'),
				};
			});

		const datesAreSameMonth = isSameMonth(parseISO(dateStr1), parseISO(dateStr2));

		const dateRange = `${date1.month} ${date1.day}`;

		if (datesAreSameMonth) {
			return `${dateRange} - ${date2.day}`;
		} else {
			return `${dateRange} - ${date2.month} ${date2.day}`;
		}
	}
}
